'use client';
import { useEffect, useMemo, useState } from 'react';
import config from '../../tailwind.config';
import resolveConfig from 'tailwindcss/resolveConfig';

const { screens } = resolveConfig(config)?.theme;

export interface NumericBreakpoints {
  sm: number;
  md: number;
  lg: number;
  xl: number;
  '2xl': number;
  '3xl': number;
}

const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState('');

  const numericBreakpoints: NumericBreakpoints = useMemo(() => {
    return Object.entries(screens).reduce((acc, [key, value]) => {
      const match =
        typeof value === 'string' ? value.match(/^([\d.]+)(rem|px)$/) : null;
      if (!match) return acc;

      const [_, num, unit] = match;
      const px = unit === 'rem' ? parseFloat(num) * 16 : parseInt(num, 10);

      acc[key as keyof NumericBreakpoints] = px;
      return acc;
    }, {} as NumericBreakpoints);
  }, []);

  useEffect(() => {
    const calculateBreakpoint = () => {
      const width = window.innerWidth;
      let currentBreakpoint = '';
      const sortedBreakpoints = Object.entries(numericBreakpoints).reverse();

      for (const [name, size] of sortedBreakpoints) {
        if (width >= size) {
          currentBreakpoint = name;
          break;
        }
      }

      setBreakpoint(currentBreakpoint || 'xs');
    };

    calculateBreakpoint();
    window.addEventListener('resize', calculateBreakpoint);

    return () => window.removeEventListener('resize', calculateBreakpoint);
  }, [numericBreakpoints]);

  return breakpoint;
};

export default useBreakpoint;
